"use client";

import { useEffect, useState } from "react";

import { useEventTracking } from "@up/analytics";

export function EventTrackingInit() {
  const [target, setTarget] = useState<HTMLElement | null>(null);
  useEventTracking(target);

  useEffect(() => {
    setTarget(document.getElementById("server-layout"));
  }, []);

  return null;
}
